import { useEffect } from 'react';
import { useOrchestratorState } from '@wix/gg-components/orchestrator';
import { useSetCurrentStepId } from 'stores/appStore';

export function useStepSync() {
  const { currentStep } = useOrchestratorState();
  const setCurrentStepId = useSetCurrentStepId();

  useEffect(() => {
    if (currentStep?.id) {
      setCurrentStepId(currentStep.id);
    }
  }, [currentStep?.id, setCurrentStepId]);
}

